const isProd =
  window.location.href.startsWith("https://app.dcompany.no") ||
  sessionStorage.getItem("env") === "prod";

const isTest =
  window.location.href.startsWith("https://test.dcompany.no") ||
  sessionStorage.getItem("env") === "test";

export function isTestEnvironment(): boolean {
  return isTest;
}

export function isProductionEnvironment(): boolean {
  return isProd;
}

export const isDevEnvironment = import.meta.hot !== undefined;
